import { render, staticRenderFns } from "./AssignmentDashboardV2.vue?vue&type=template&id=77e23356&scoped=true&"
import script from "./AssignmentDashboardV2.vue?vue&type=script&lang=js&"
export * from "./AssignmentDashboardV2.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDashboardV2.vue?vue&type=style&index=0&id=77e23356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e23356",
  null
  
)

export default component.exports